import styles from '../../index.module.css'
import React, { useState } from 'react'
import PbButton from '../button/button.component';

interface SearchProps {
  onSearchButtonClick: (value: string) => void
}

export default function Search({ onSearchButtonClick }: SearchProps) {
  const [searchTerm, setSearchTerm] = useState('');

  const onKeyDown = async (e: any) => {
    if (e.keyCode === 13)
      onSearchButtonClick(searchTerm);
  }

  return (<div className={styles.searchBar}>
      <input
        name="txtsearch"
        type="search"
        enterKeyHint="search"
        aria-label="Pesquisar partituras"
        className={styles.urltext}
        placeholder="Digite sua pesquisa..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyUp={onKeyDown}
      />
      <PbButton label='Buscar' onClick={() => onSearchButtonClick(searchTerm)} />
    </div>)
}